


































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
    }),
    ...mapState('ServiceOrder', {
      newBulkServiceOrder: 'newBulkServiceOrder',
    }),
  },
})
export default class ServiceOrderCreateOrderDetailsReview extends Vue {
  @Prop({ default: true }) readonly selectedBusiness!: Model;
  newBulkServiceOrder!: ServiceOrderState['newBulkServiceOrder'];

  serviceItems!: Model[];

  get totalOrderDetailsAmount() {
    return this.$store.getters['ServiceOrder/totalOrderDetailsAmount'](
      this.selectedBusiness.gst_rate_applied
    );
  }

  get totalOrderDetailsSubtotal() {
    return (
      this.totalOrderDetailsAmount /
      (1 + this.selectedBusiness.gst_rate_applied)
    );
  }

  get totalOrderDetailsGst() {
    return this.totalOrderDetailsAmount - this.totalOrderDetailsSubtotal;
  }
}
